var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('the-header'),_c('the-content',[_c('h1',{staticClass:"main-headline"},[_vm._v("Umbruch")]),_c('p',[_vm._v("Lorem ipsum dolor sit amet")]),_c('indentation-overview'),_c('indentation-preview')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }